var generateStyle = function generateStyle(componentTheme) {
  return {
    quizResults: {
      marginTop: componentTheme.quizResultsMargin,
      width: '100%',
      height: '100%'
    },
    footer: {
      padding: '1rem',
      display: 'flex',
      justifyContent: 'flex-end'
    },
    toggleDetailsWrapper: {
      marginLeft: componentTheme.resultsFeedbackMargin
    }
  };
};
export default generateStyle;